import { render, staticRenderFns } from "./SimpleBoxLayout.vue?vue&type=template&id=598ad69d&scoped=true"
import script from "./SimpleBoxLayout.vue?vue&type=script&lang=js"
export * from "./SimpleBoxLayout.vue?vue&type=script&lang=js"
import style0 from "./SimpleBoxLayout.vue?vue&type=style&index=0&id=598ad69d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598ad69d",
  null
  
)

export default component.exports